
document.addEventListener("DOMContentLoaded", function () {
// Remove copyright icon Formbuilder
const timer = setInterval(() => {
  let selector = document.querySelector('.storeify-formbuilder img');
  if (selector) {
    selector.remove();
    clearInterval(timer);
  }else if (timer > 5000){ clearInterval(timer); }
}, 100);

}); // fine DOMContentLoaded